// Thin wrapper over /api/blockmarkers - mirrors notesApi.js exactly (same
// backend author, same "bare scalar id in request bodies, full nested
// objects in GET responses" convention). One marker per target (unlike
// notes, which allow many) - createMarker/updateMarker enforce that at the
// call-site in blockMarkerUtils, this file just does the HTTP shape.

import axios from 'axios';

const jsonHeaders = {
   withCredentials: true,
   headers: { 'Content-Type': 'application/json' },
};

// One call, every marker for the whole workspace (every target kind at
// once) - grouped client-side, same pattern as getNotesForWorkspace.
export function getMarkersForWorkspace(workspaceId) {
   return axios.get('/api/blockmarkers?workspace=' + workspaceId, { withCredentials: true });
}

// kind is 'topicElement' | 'topicContainer' | 'topicExerciseTemplate' -
// exactly one of these three fields is ever set on the backend entity.
export function createMarker(workspaceId, kind, targetId, markerType) {
   const payload = { workspace: workspaceId, markerType };
   payload[kind] = targetId;
   return axios.post('/api/blockmarkers', JSON.stringify(payload), jsonHeaders);
}

// Full-replace PUT (this backend's Service.update() never partial-patches) -
// resend the existing marker's relation fields flattened to bare ids, only
// markerType actually changes.
export function updateMarker(marker, markerType) {
   const idOf = (v) => (v && typeof v === 'object' ? v.id : v);
   const payload = {
      id: marker.id,
      workspace: idOf(marker.workspace),
      topicElement: marker.topicElement ? idOf(marker.topicElement) : null,
      topicContainer: marker.topicContainer ? idOf(marker.topicContainer) : null,
      topicExerciseTemplate: marker.topicExerciseTemplate ? idOf(marker.topicExerciseTemplate) : null,
      markerType,
   };
   return axios.put('/api/blockmarkers/' + marker.id, JSON.stringify(payload), jsonHeaders);
}

export function deleteMarker(markerId) {
   return axios.delete('/api/blockmarkers/' + markerId, { withCredentials: true });
}
